import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { processLocationData } from "./processLocationData";
import { RootState } from "../../../Redux/store";

const baseUrl = 'https://customer.hirsch.com/v2/branches';

export const getBranches = createAsyncThunk<any[], void, {state: RootState}> (
    'locations/getBranches',
    async(_,{ getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;

            if (!token) {
                throw new Error('No Auth Token Found');
            }

            const response = await fetch(baseUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            })

            if(!response.ok) throw new Error('Failed to fetch');
            const json = await response.json();

            let processedData;
            
            if (json.branches) {
                processedData = processLocationData(json.branches);
            }

            return processedData;
        } catch (err: any) {
            return rejectWithValue(err.message);
        } 
    }
)

interface LocationState {
    locationsArr: any[];
    loading: boolean;
    error: string | boolean | null | undefined;
}

const initialState: LocationState = {
    locationsArr: [],
    loading: false,
    error: null,
}

const locationSlice = createSlice({
    name: 'locations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getBranches.pending, (state) => {
            state.loading = true;
            state.error = false;
        })
        .addCase(getBranches.fulfilled, (state, action) => {
            state.loading = false;
            state.locationsArr = action.payload
            state.error = false;
        })
        .addCase(getBranches.rejected, (state, action) => {
            state.loading = false
            state.error = action.error ? action.error.message : 'Failed to Fetch';
        })
    }
})

export const locationsReducer = locationSlice.reducer;

export const getLocations = (state: RootState) => {
    return state.locations.locationsArr;
}